/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_End_ConfirmInputs */

const en_us2_workout_after_end_confirm = /** @type {(inputs: Workout_After_End_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End workout`)
};

const pt_br2_workout_after_end_confirm = /** @type {(inputs: Workout_After_End_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrar treino`)
};

const es_419_workout_after_end_confirm = /** @type {(inputs: Workout_After_End_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar entrenamiento`)
};

const pt_pt2_workout_after_end_confirm = /** @type {(inputs: Workout_After_End_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar treino`)
};

const fr_fr2_workout_after_end_confirm = /** @type {(inputs: Workout_After_End_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer la séance`)
};

const de_de2_workout_after_end_confirm = /** @type {(inputs: Workout_After_End_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training beenden`)
};

const it_it2_workout_after_end_confirm = /** @type {(inputs: Workout_After_End_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina allenamento`)
};

/**
* | output |
* | --- |
* | "End workout" |
*
* @param {Workout_After_End_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_end_confirm = /** @type {((inputs?: Workout_After_End_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_End_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_end_confirm(inputs)
	if (locale === "es-419") return es_419_workout_after_end_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_end_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_end_confirm(inputs)
	if (locale === "de-DE") return de_de2_workout_after_end_confirm(inputs)
	if (locale === "it-IT") return it_it2_workout_after_end_confirm(inputs)
	return en_us2_workout_after_end_confirm(inputs)
});
export { workout_after_end_confirm as "workout-after.end_confirm" }